<template>
    <div>
        <b-row>
            <b-col class="header-menu-text">
                <h5 class="text-secondary">Shipping</h5>
            </b-col>

            <b-col class="text-right" v-if="!printView">
                <b-dropdown ref="trackingDropdown" no-caret size="sm" variant="link" class="menu-btn" toggle-class="text-decoration-none" right>
                    <template #button-content>
                        <b-button variant="outline-secondary" size="sm">
                            <b-icon-plus></b-icon-plus>
                        </b-button>
                    </template>

                    <shipment @addTracking="addShipment($event)"></shipment>
                </b-dropdown>
            </b-col>
        </b-row>


        <div v-if="!printView">
            <b-row class="mb-3">
                <b-col>
                    <b-input-group size="sm">
                        <b-input-group-prepend size="sm" style="width: 8rem;">
                            <b-input size="sm" disabled value="Method"></b-input>
                        </b-input-group-prepend>

                        <b-form-select v-model="component.method" :options="shippingOptions" :class="{ 'is-invalid': !component.method }">
                            <template #first>
                                <b-form-select-option disabled :value="null">Method</b-form-select-option>
                            </template>
                        </b-form-select>

                        <b-input-group-prepend size="sm" style="width: 8rem;">
                            <b-input size="sm" disabled value="Cost"></b-input>
                        </b-input-group-prepend>

                        <b-input :value="shippingTotal" disabled></b-input>
                    </b-input-group>
                </b-col>
            </b-row>

            <b-row v-for="(shipment, index) in component.shipments" v-bind:key="'shipment-' + index" class="mb-3">
                <b-col>
                    <b-input-group size="sm" prepend="Shipment">
                        <b-link v-if="shipment.tracking" :href="trackingLink(shipment.tracking, shipment.trackingUrl)" target="_blank" class="form-control text-primary">{{ shipment.tracking }}</b-link>
                        <span v-else class="form-control"><em>(no tracking)</em></span>
                        <b-link v-if="shipment.labelUrl" target="_blank" :href="shipment.labelUrl" class="form-control text-primary" style="max-width: 4rem;">View</b-link>

                        <b-input-group-append v-if="shipment.username">
                            <b-button size="sm" :id="'shipmentuser-' + index" variant="outline-info">
                                <b-icon-person></b-icon-person>
                            </b-button>

                            <b-tooltip :target="'shipmentuser-' + index" triggers="hover">
                                {{ shipment.username }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append v-if="shipment.weight">
                            <b-button size="sm" :id="'shipmentweight-' + index" variant="outline-info">
                                <b-icon-box-seam></b-icon-box-seam>
                            </b-button>

                            <b-tooltip :target="'shipmentweight-' + index" triggers="hover">
                                {{ shipment.weight }} lbs.
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append v-if="shipment.date">
                            <b-button size="sm" :id="'shipmentdate-' + index" variant="outline-info">
                                <b-icon-calendar4-event></b-icon-calendar4-event>
                            </b-button>

                            <b-tooltip :target="'shipmentdate-' + index" triggers="hover">
                                {{ moment(shipment.date).format('M/D/YYYY h:mma') }}
                            </b-tooltip>
                        </b-input-group-append>
                        


                        <div v-for="(delivery, index) in delivery" :key="'delivery-' + index">
                            <b-input-group-append v-if="delivery.tracking === shipment.tracking">
                            <b-button size="sm" :id="'deliveryinfo-' + index" variant="outline-info">
                                <b-icon-calendar-check></b-icon-calendar-check>
                            </b-button>

                            <b-tooltip :target="'deliveryinfo-' + index" triggers="hover" >
                               Delivered on {{ moment(delivery.date).format('M/D/YYYY h:mma') }}
                            </b-tooltip>
                        </b-input-group-append>
                        </div>
                      

                        <b-input-group-append v-if="orderId">
                            <b-button size="sm" :id="'shipmentemail-' + index" variant="outline-primary" @click="sendShipmentEmail()">
                                <b-icon-envelope></b-icon-envelope>
                            </b-button>

                            <b-tooltip :target="'shipmentemail-' + index" triggers="hover">
                                Send shipment email
                            </b-tooltip>
                        </b-input-group-append>

                         <b-input-group-append v-if="shipment.shipmentId">
                            <b-button size="sm" :id="'shipmentinfo-' + index" variant="outline-primary" @click="getShipmentInfo(shipment.shipmentId, shipment.tracking)">
                                <b-icon-info-circle></b-icon-info-circle>
                            </b-button>

                            <b-tooltip :target="'shipmentinfo-' + index" triggers="hover">
                                Shipment Info
                            </b-tooltip>
                        </b-input-group-append>


                        <b-input-group-append>
                            <b-button size="sm" :id="'delete-' + index" variant="outline-danger" @click="deleteShipment(index)">
                                <b-icon-x-circle></b-icon-x-circle>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
        </div>

        <div v-else>
            <b-row>
                <b-col sm="3">Method</b-col>
                <b-col>{{ method }}</b-col>
            </b-row>

            <b-row>
                <b-col sm="3">Cost</b-col>
                <b-col>${{ shippingTotal }}</b-col>
            </b-row>

            <div v-for="(shipment, index) in component.shipments" v-bind:key="'shipment-' + index">
                <h6 v-if="component.shipments.length > 1" class="mt-3">Shipment {{ index + 1}}</h6>
                <b-row>
                    <b-col sm="3">Tracking</b-col>
                    <b-col><b-link :href="trackingLink(shipment.tracking)" target="_blank">{{ shipment.tracking }}</b-link></b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Date</b-col>
                    <b-col>{{ moment(shipment.date).format('M/D/YYYY h:mma') }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Shipped By</b-col>
                    <b-col>{{ shipment.username }}</b-col>
                </b-row>

                <b-row v-if="shipment.labelUrl">
                    <b-col sm="3">Postage Label</b-col>
                    <b-col><b-link target="_blank" :href="shipment.labelUrl">View</b-link></b-col>
                </b-row>
            </div>
        </div>
            <b-modal id="shipmentModal"
             title="Shipment Info"
             size="lg"
             scrollable
             button-size="sm"
             hide-footer
             centered>
             <b-row>
                <b-col>
                    <h5>Shipment</h5>
                    <p>Created: {{ shipmentInfo.created_at }}</p>
                     <p>Ship Date: {{ labelInfo.ship_date }}</p>

                    <p>Service Code: {{ readableCode(shipmentInfo.service_code) }}</p>
                       <p>Shipment ID: {{ shipmentInfo.shipment_id }}</p>
                    <!-- <p>Total Weight: <pre>{{ shipmentInfo.total_weight }}</pre></p> -->

                    <p>Carrier Code: {{ readableCode(labelInfo.carrier_code) }}</p>
                    <p>Customs Form: <a v-if="labelInfo.form_download" :href="labelInfo.form_download.href" target="_blank">{{ labelInfo.form_download.href }}</a></p>
                    <p>Label: <a v-if="labelInfo.label_download" :href="labelInfo.label_download.pdf" target="_blank">{{ labelInfo.label_download.pdf }}</a></p>

                    <!-- <p v-if="labelInfo.label_download">Label Download: <pre>{{ labelInfo.label_download.pdf }}</pre></p> -->
                    <p>Label ID: {{ labelInfo.label_id }}</p>
                    <p>Tracking URL: <a v-if="labelInfo.tracking_url" target="_blank" :href="labelInfo.tracking_url">{{ labelInfo.tracking_url }}</a></p>
                    
                    <div v-if="labelInfo.shipment_cost">
                        <p>Shipment Cost: ${{ labelInfo.shipment_cost.amount }}</p>
                    </div>

                    <h5 v-if="labelInfo.rate_details">Rate Details</h5>
                    <div v-for="(rate, i) in labelInfo.rate_details" :key="'rate' + i">
                        
                        <p>Carrier Description: {{ rate.carrier_description }}</p>
                        <p v-if="rate.carrier_memo">Carrier Memo: {{ rate.carrier_memo }}</p>
                        <p v-if="rate.billing_source">Billing Source: {{ rate.billing_source }}</p>
                        <p v-if="rate.carrier_billing_code">Carrier Billing Code: {{ rate.carrier_billing_code }}</p>
                        <p>Amount: ${{ rate.amount.amount }}</p>
                        <!-- <p>Currency: {{ rate.amount.currency }}</p> -->
                    </div>
                        

                    <div v-if="shipmentInfo.ship_to">
                    <h5>Ship To</h5>
                    <p>Name: {{ shipmentInfo.ship_to.name }}</p>
                    <p>Phone: {{ shipmentInfo.ship_to.phone }}</p>
                    <p>Address: {{ shipmentInfo.ship_to.address_line1 }}</p>
                    <p v-if="shipmentInfo.ship_to.address_line2">Address 2: {{ shipmentInfo.ship_to.address_line2 }}</p>
                    <p v-if="shipmentInfo.ship_to.address_line3">Address 3: {{ shipmentInfo.ship_to.address_line3 }}</p>

                    <p>City: {{ shipmentInfo.ship_to.city_locality }}</p>
                    <p>State: {{ shipmentInfo.ship_to.state_province }}</p>
                    <p>Zip: {{ shipmentInfo.ship_to.postal_code }}</p>
                    <p>Country: {{ shipmentInfo.ship_to.country_code }}</p>
                    <p>Email: {{ shipmentInfo.ship_to.email }}</p>
                    </div>
                    <!-- <p>Ship To: <pre>{{ shipmentInfo.ship_to }}</pre></p> -->
                    <!-- <span>Items: <pre>{{ shipmentInfo.items }}</pre></span> -->
                    <div v-if="shipmentInfo.packages">
                        <h5>Package</h5>
                        <p >Weight: {{ shipmentInfo.packages[0].weight.value }} {{ shipmentInfo.packages[0].weight.unit }}s</p>
                        <p >Dimensions: {{ shipmentInfo.packages[0].dimensions.width }}" x  {{ shipmentInfo.packages[0].dimensions.length }}" x  {{ shipmentInfo.packages[0].dimensions.height }}" </p>
                        <p >Package Code: {{ readableCode(shipmentInfo.packages[0].package_code) }}</p>

                        <h5>Customs Items</h5>
                         <div v-for="(product, i) in shipmentInfo.packages[0].products" :key="'product'+i">
                            <p>SKU {{ product.sku }}</p>
                            <p>Value: ${{ product.value.amount }}</p>
                            <p>Harmonized Tarrif Code: {{ product.harmonized_tariff_code }}</p>
                            <p >Weight: {{ product.weight.value }} {{ product.weight.unit }}s</p>
                        </div>
                    </div>

                   
                    <!-- <p>Packages: <pre>{{ shipmentInfo.packages }}</pre></p> -->
                   
                 

                </b-col>
            </b-row>
         
        </b-modal>
    </div>
    
</template>

<script>
    import moment from "moment";
    import Shipment from "./Shipment";
    import ObjectMixin from "../../mixins/object";
    import ShippingOptionsMixin from "../../assets/shippingOptions";
    import shippingApi from "@/api/shipping";
    import utils from "../../mixins/utils";

    export default {
        name: "Shipping",
        props: [ 'shipping', 'printView', 'shippingTotal', 'orderId', 'delivery' ],
        mixins: [ ObjectMixin, ShippingOptionsMixin, shippingApi, utils ],
        components: { Shipment },
        created() {
            const shippingClone = this.deepClone(this.shipping);
            this.clone(shippingClone);
        },
        data() {
            return {
                shipmentInfo: {},
                labelInfo: {},
            }
        },
        methods: {
            readableCode(snakeStr) {
                if (!snakeStr) {
                    return '';
                }
                return snakeStr
                        .split('_')  // Split by underscores
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))  // Capitalize first letter
                        .join(' ');  // Join with spaces
            },
            trackingLink(tracking, trackingUrl) {
                if (trackingUrl) {
                    return trackingUrl;
                }

                if (!isNaN(tracking)) {
                    return `${process.env.VUE_APP_USPS_TRACKING_URL}${tracking}`;
                }

                return `${process.env.VUE_APP_LANDMARK_TRACKING_URL}${tracking}`;
            },
            addShipment(tracking) {
                const shipmentObj = {
                    username: this.$auth.user.nickname,
                    date: moment().format(),
                    tracking: tracking,
                };

                if (!this.component.shipments) {
                    this.component.shipments = [];
                }

                this.component.shipments.push(shipmentObj);

                this.$emit('update', this.component);

                this.$refs.trackingDropdown.hide();
            },
            async deleteShipment(index) {
                const shipment = this.component.shipments[index];
                if (!shipment) {
                    return;
                }

                if (!window.confirm(`Cancel shipment ${shipment.tracking || ''}?`)) {
                    return;
                }

                try {
                    // Cancel the postage label with the shipping API, like the Shipping tab
                    if (shipment.labelId) {
                        await this.cancelLabel(shipment.labelId);
                    }

                    // Remove shipment from the order and notify parent
                    this.component.shipments.splice(index, 1);
                    this.$emit('update', this.component);
                } catch (error) {
                    // Reuse existing error handling mixin
                    if (this.showError) {
                        this.showError(error, 'Cancel Shipment');
                    } else {
                        // eslint-disable-next-line no-console
                        console.error('Error cancelling shipment', error);
                    }
                }
            },
            async sendShipmentEmail() {
                try {
                    await this.sendShippingConfirmation([ this.orderId ]);
                    this.showToast('Shipping Confirmation', 'Sent to customer.');
                } catch (error) {
                    this.showError(error, 'Shipping Confirmation');
                }
            },
            async getShipmentInfo(shipmentId, trackingNumber) {
                this.$bvModal.show('shipmentModal');
                const shipmentInfo = await this.getShipmentData(shipmentId);
                console.log(shipmentInfo);
                this.shipmentInfo = shipmentInfo.shipmentData;
                
                const labelInfo = await this.getLabelData(trackingNumber);
                console.log(labelInfo);
                this.labelInfo = labelInfo.labelData;
            }
        },
        computed: {
            method() {
                if (this.component.method) {
                    return this.component.method;
                }

                if (this.component[0] && this.component[0].method) {
                    return this.component[0].method;
                }

                return '';
            },
            cost() {
                if (this.component.cost) {
                    return this.component.cost;
                }

                if (this.component[0] && this.component[0].cost) {
                    return this.component[0].cost;
                }

                return 0;
            }
        }
    }
</script>

<style scoped>
    .input-group-text {
        width: 8rem;
    }
</style>